export default "__VITE_ASSET__deeec560__"